// extracted by mini-css-extract-plugin
module.exports = {"icon":"AngleIcon_icon__uBNTB"};